import React from "react";
import { Route, Routes } from "react-router-dom";
import { MainLayout } from "./layout/mainLayout";
import { Dashbourd } from "./pages/dashboard";
import { useIndustryRoutes } from "./pages/industry";
import { useCompanyRoutes } from "./pages/company";
import { LoginPage } from "./pages/auth/loginPage";
import { RequireAuth } from "./authorize/requireAuth";
import "./App.css";
import { useActivityGroupRoutes } from "./pages/activityGroup";
import { useShareholderGroupRoutes } from "./pages/shareholderGroup";
import { useCompanyIdentityRoutes } from "./pages/companyIdentity";
import { useShareholderRoutes } from "./pages/shareholder";
import { useCompanyShareholderRoutes } from "./pages/companyShareholder";
import { useArticleCategoryRoutes } from "./pages/articleCategory";
import { useGeneralInfoRoutes } from "./pages/generalInfo";
import { useStatInfoRoutes } from "./pages/statInfo";
import { useSubscriptionRoutes } from "./pages/subscription/routes";
import { JalaliLocaleListener } from "antd-jalali";
import { useDiscountRoutes } from "./pages/discount/routes";
import { useFinancialStatementRoutes } from "./pages/financialStatement";
import { useMonthlyPerformanceRoutes } from "./pages/monthlyPerformance";
import { useAnnouncementRoutes } from "./pages/announcement";
import { useGlanceRoutes } from "./pages/glance";
import { getContactMessageRoutes } from "./pages/contactMessage/routes";
import { useProductRoutes } from "./pages/product";
import { useGlanceAdjustmentRoutes } from "./pages/glanceAdjustment";
import { useGlanceAdjustmentMarkRoutes } from "./pages/glanceAdjustmentMark";
import { useShareholderEnterLeaveRoutes } from "./pages/shareholderEnterLeave";
import { useUserRoutes } from "./pages/user";
import { useArticleSubCategoryRoutes } from "./pages/articleSubCategory";
import { useAuthorRoutes } from "./pages/author";
import { useAuthorGroupRoutes } from "./pages/authorGroup";
import { useArticleRoutes } from "./pages/article";
import { useAccountRoutes } from "./pages/account";
import { useCostRoutes } from "./pages/cost";
import { useOaCostRoutes } from "./pages/oaCost";
import { useInventoryTurnoverRoutes } from "./pages/inventoryTurnover";
import { usePcRawMaterialRoutes } from "./pages/pcRawMaterial";
import { usePackageRoutes } from "./pages/package";
import { useDurationRoutes } from "./pages/duration";
import { useArticleDurationTypeRoutes } from "./pages/articleDurationType";
import { useOieRoutes } from "./pages/oie";
import { useAgRequestRoutes } from "./pages/addAuthorToGroupRequest";
import { useBankAccountRoutes } from "./pages/bankAccount";
import { useAuthorCooperationRoutes } from "./pages/authorCooperation";
import { useArticleContractRoutes } from "./pages/articleContract";
import { useScoringConfigRoutes } from "./pages/scoringConfig";
import { useScoringLogRoutes } from "./pages/scoringLog";
import { useArticleSubscriptionRoutes } from "./pages/articleSubscription";
import { useArticleInvoiceRoutes } from "./pages/articleInvoice";
import { useDpsRoutes } from "./pages/dps";
import { useMonthlyEnergyRoutes } from "./pages/monthlyEnergy";
import { useMonthlyRawMaterialRoutes } from "./pages/monthlyRawMaterial";
import { useFcFlowRoutes } from "./pages/fcFlow";
import { useMessageRoutes } from "./pages/message";
import { useNotificationRoutes } from "./pages/notification";
import { useInvestmentReviewRoutes } from "./pages/investmentReview";
import { useInvestmentReportRoutes } from "./pages/investmentReport";
import { useAuthBootstrap } from "./features/auth/useAuthBootstrap";

function App() {
  useAuthBootstrap();

  return (
    <React.Fragment>
      <JalaliLocaleListener />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* <Route path="/forgotPassword" element={React.lazy(() => import('./components/pages/ForgotPasswordPage'))} /> */}
        <Route
          path="/"
          element={
            <RequireAuth policies={["AdminPanel-Enter"]} redirect={true}>
              <MainLayout />
            </RequireAuth>
          }>
          <Route index element={<Dashbourd />} />
          {useIndustryRoutes()}
          {useActivityGroupRoutes()}
          {useCompanyRoutes()}
          {useArticleCategoryRoutes()}
          {useArticleSubCategoryRoutes()}
          {useAuthorGroupRoutes()}
          {useAuthorRoutes()}
          {useArticleRoutes()}
          {useArticleDurationTypeRoutes()}
          {useShareholderGroupRoutes()}
          {useArticleSubscriptionRoutes()}
          {useArticleInvoiceRoutes()}
          {useCompanyIdentityRoutes()}
          {useShareholderRoutes()}
          {useCompanyShareholderRoutes()}
          {useGeneralInfoRoutes()}
          {useStatInfoRoutes()}
          {useSubscriptionRoutes()}
          {useDiscountRoutes()}
          {useFinancialStatementRoutes()}
          {useMonthlyPerformanceRoutes()}
          {useMonthlyRawMaterialRoutes()}
          {useFcFlowRoutes()}
          {useMonthlyEnergyRoutes()}
          {useAnnouncementRoutes()}
          {useGlanceRoutes()}
          {getContactMessageRoutes()}
          {useProductRoutes()}
          {useGlanceAdjustmentRoutes()}
          {useGlanceAdjustmentMarkRoutes()}
          {useShareholderEnterLeaveRoutes()}
          {useUserRoutes()}
          {useAccountRoutes()}
          {useCostRoutes()}
          {useOaCostRoutes()}
          {useInventoryTurnoverRoutes()}
          {usePcRawMaterialRoutes()}
          {useDpsRoutes()}
          {usePackageRoutes()}
          {useDurationRoutes()}
          {useOieRoutes()}
          {useAgRequestRoutes()}
          {useBankAccountRoutes()}
          {useAuthorCooperationRoutes()}
          {useArticleContractRoutes()}
          {useScoringConfigRoutes()}
          {useScoringLogRoutes()}
          {useMessageRoutes()}
          {useNotificationRoutes()}
          {useInvestmentReviewRoutes()}
          {useInvestmentReportRoutes()}
        </Route>
      </Routes>
    </React.Fragment>
  );
}

export default App;
